// Any Constants which are global will sit here.

export const KeyCode = {
	Enter: 13
};

// To optimise, we should look to consistently use one of these two
export const Key = {
	ArrowDown: 'ArrowDown',
	ArrowUp: 'ArrowUp',
	Enter: 'Enter',
	Escape: 'Escape',
	Space: ' ',
	Tab: 'Tab'
};

export const VIMEO_ACCESS_TOKEN = '03bb633ecf5f4b0245f313912c44bbc4';